<template>
  <section>
    <div
      class="modal-card"
      style="width: auto"
    >

      <header class="modal-card-head">
        <div
          v-if="$store.state.connectionEdit.mode == 'new'"
          class="title is-bold"
        >New Connection</div>
        <div
          v-if="$store.state.connectionEdit.mode == 'edit'"
          class="title is-bold"
        >Edit Connection</div>
      </header>

      <section class="modal-card-body">

        <div
          class="subtitle is-bold"
          v-if="$store.state.connectionEdit.mode == 'new'"
        >Create a new connection. This is a person or company that you do business with in your real estate investing.</div>
        <div
          class="subtitle is-bold"
          v-if="$store.state.connectionEdit.mode == 'edit'"
        >Change connection information. Update any information about this connection, like their type, name, email or phone.</div>

        <b-field
          horizontal
          label="Type"
        >
          <b-input
            @focus="$event.target.select()"
            name="type"
            v-model="c.type"
            type="text"
            placeholder="Type of connection (Agent, Inspector, etc)"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Name"
        >
          <b-input
            @focus="$event.target.select()"
            name="name"
            v-model="c.name"
            type="text"
            placeholder="Connection's name (person or business)"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Email"
        >
          <b-input
            @focus="$event.target.select()"
            name="email"
            v-model="c.email"
            type="text"
            placeholder="Connection's email address"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Phone"
        >
          <b-input
            @focus="$event.target.select()"
            name="phone"
            v-model="c.phone"
            type="text"
            placeholder="Connection's phone number"
            expanded
          ></b-input>
        </b-field>

        <b-message
          type="is-danger"
          has-icon
          v-if="this.errorMessage"
        >
          {{ this.errorMessage }}
        </b-message>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          v-if="$store.state.connectionEdit.mode == 'new'"
          :disabled="c.type.length == 0 || c.name.length == 0"
          class="button is-primary"
          @click="() => { saveNew(); $parent.close() }"
        >Create new connection</button>
        <button
          v-if="$store.state.connectionEdit.mode == 'edit'"
          :disabled="c.type.length == 0 || c.name.length == 0"
          class="button is-primary"
          @click="() => { saveEdit(); $parent.close() }"
        >Save changes</button>
      </footer>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      c: { id: "", type: "", name: "", email: "", phone: "" }
    };
  },

  computed: {
    connection() {
      return this.$store.state.connectionEdit.connection;
    },
    originalConnection() {
      return this.$store.state.connectionEdit.originalConnection;
    }
  },

  mounted() {
    this.c.id = this.$store.state.connectionEdit.connection.id;
    this.c.type = this.$store.state.connectionEdit.connection.type;
    this.c.name = this.$store.state.connectionEdit.connection.name;
    this.c.email = this.$store.state.connectionEdit.connection.email;
    this.c.phone = this.$store.state.connectionEdit.connection.phone;
  },

  methods: {
    cancel() {
      console.log("cancel()");
    },

    async saveNew() {
      var user = this.$store.getters.session.user;
      var connection = this.c;
      await this.$store
        .dispatch("newUserConnection", {
          user,
          connection
        })
        .then(async response => {
          console.log(response);
          var userId = user.id;
          var includeHidden = true;
          await this.$store.dispatch("getUserConnections", {
            userId,
            includeHidden
          });
        });
    },

    async saveEdit() {
      console.log("saveEdit()", this.c);
      var userId = this.$store.getters.session.user.id;
      var connection = this.c;
      await this.$store.dispatch("updateUserConnection", {
        userId,
        connection
      });
      var foundIndex = this.$store.state.connections.findIndex(
        x => x.id == this.c.id
      );
      this.$store.state.connections[foundIndex].type = this.c.type;
      this.$store.state.connections[foundIndex].name = this.c.name;
      this.$store.state.connections[foundIndex].email = this.c.email;
      this.$store.state.connections[foundIndex].phone = this.c.phone;
    }
  }
};
</script>

<style>
</style>
